<template>
  <span v-html="highlighted"></span>
</template>

<script>
  export default {
    props: ['string', 'search'],

    computed: {
      highlighted() {
        return this.string.replace(new RegExp(`(${this.search})`, 'i'), '<em>$1</em>')
      }
    }
  }
</script>

<style scoped>
  span >>> em {
    background-color: rgba(230, 230, 143, 0.5);
  }
</style>